import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';

interface ModalNovoServicoProps {
    modalStatus?: any,
    setNovoServicoModal?: any
}

const ModalNovoServico: React.FC<ModalNovoServicoProps> = (prop) => {
    let visible = prop.modalStatus[0].visibleNovoServico
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;    

    useEffect(() => {
        form.resetFields();
    }, [visible])

    const handleCancel = () => {
        prop.setNovoServicoModal(false)
    };

    const onFinish = (values: any) => {
        setLoading(true);
        api.post(`Servico`, {
            ServicoID: undefined,
            Descricao: values.descricao,
            Ativo: true,
        })
            .finally(()=>  setLoading(false))
            .then((response) => {
                if (response.data.valido) {
                    message.success('Serviço salvo com sucesso')                   
                    prop.setNovoServicoModal(false);
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            });
    };


    return (
        <Modal
            visible={visible}
            title="Novo Serviço"
            footer={null}
            onCancel={handleCancel}
        >
            <Form name="basic" form={form} onFinish={onFinish} labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} >
                <Form.Item label="ServicoID" name="servicoID" hidden={true}>
                    <Input type="number" hidden={true} />
                </Form.Item>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>

                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Descrição"
                            name="descricao"
                        >
                            <Input placeholder="Digite a descrição"></Input>
                        </Form.Item>
                    </Col>

                   
                </Row>
                <Form.Item>
                    <Button loading={loading} className="button-pre-cadastro" type="primary" htmlType="submit">
                        Salvar
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalNovoServico);